import React from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './app/main';
import Prueba from './app/pdfs/TasaMunicipalEzeiza'


function App() {
  return (
    <div className="App">
      <div>
          <Header
          op={2278} tipo_deduc={888}
          ejercicio={2020}
          ></Header>
      </div>
    </div>
  );
}

export default App;
